module.exports = __webpack_public_path__ + "img/document-icon.19b6cb18.svg";